"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.motivationForJoiningSelect = exports.motivationForJoiningItems = exports.motivationForJoiningConfig = exports.MotivationForJoiningDefinition = void 0;

var _types = require("../../types");

var _config = require("../config");

var _selectConfig = require("../../fields/Select/selectConfig");

var _flowRuntime = _interopRequireDefault(require("flow-runtime"));

var SelectDefinition = _flowRuntime["default"].tdz(function () {
  return _selectConfig.SelectDefinition;
});

var ListComponentConfigDefinition = _flowRuntime["default"].tdz(function () {
  return _config.ListComponentConfigDefinition;
});

var ComponentElementDefinition = _flowRuntime["default"].tdz(function () {
  return _types.ComponentElementDefinition;
});

var OptionDefinition = _flowRuntime["default"].tdz(function () {
  return _types.OptionDefinition;
});

var motivationForJoiningSelect = {
  key: 'reason',
  label: 'What motivated you to join the register today?',
  type: 'select',
  items: [],
  validation: [{
    required: true
  }]
};
exports.motivationForJoiningSelect = motivationForJoiningSelect;
var motivationForJoiningItems = [];
exports.motivationForJoiningItems = motivationForJoiningItems;
var motivationForJoiningConfig = {
  type: 'motivationForJoining',
  defaultItems: motivationForJoiningItems,
  fields: [motivationForJoiningSelect]
};
exports.motivationForJoiningConfig = motivationForJoiningConfig;

var MotivationForJoiningDefinition = _flowRuntime["default"].type("MotivationForJoiningDefinition", _flowRuntime["default"].spread(_flowRuntime["default"].ref(ComponentElementDefinition), _flowRuntime["default"].object(_flowRuntime["default"].property("items", _flowRuntime["default"].array(_flowRuntime["default"].ref(OptionDefinition))), _flowRuntime["default"].property("appealItems", _flowRuntime["default"].array(_flowRuntime["default"].ref(OptionDefinition))), _flowRuntime["default"].property("type", _flowRuntime["default"].string("motivationForJoining")))));

exports.MotivationForJoiningDefinition = MotivationForJoiningDefinition;